$milis_snake_app $mol_page
	title \CRUSивая Змейка
	snake_seed \4s76OmhG_LfZhGVGd
	max_x 4
	max_y 3
	person $milis_snake_person_crus
	plugins /
		<= Player_keyboard $mol_hotkey
			key * 
				A? <=> left?
				left? <=> left?
				D? <=> right?
				right? <=> right?
				S? <=> down?
				down? <=> down?
				W? <=> top?
				up? <=> top?
	foot /
		<= Status $hyoo_crus_status
	body /
		<= Score $mol_text text <= score_text \Очки: 1
		<= Keyboard $milis_snake_app_keyboard
			left? <= left? null
			right? <= right? null
			top? <= top? null
			down <= down? null
		<= Y $mol_list rows <= y_list /
			<= X*0 $mol_row sub <= x_list* /
				<= Cell*0_0 $milis_snake_app_cell
					cell_title <= cell_title* \
					is_cell_food <= is_cell_food* false
					is_cell_snake <= is_cell_snake* false
					is_cell_snake_head <= is_cell_snake_head* false
		<= Chat $mol_chat
			opened true
			sub null
			seed \uv1w0i_p0lo5c
			pages => chat_pages
		<= Pages2 $mol_view sub <= chat_pages
		<= Logs $mol_text text <= logs \

$milis_snake_app_cell $mol_button_major
	title <= cell_title \0_0
	attr *
		^
		food <= is_cell_food false
		snake <= is_cell_snake false
		head <= is_cell_snake_head false

$milis_snake_app_keyboard $mol_row
	sub /
		<= Left $mol_button_major
			sub / <= Left_icon $mol_icon_arrow_left_bold
			click? <=> left? null
		<= Vertical $mol_list rows /
			<= Top $mol_button_major
				sub / <= Top_icon $mol_icon_arrow_up_bold
				click? <=> top? null
			<= Down $mol_button_major
				sub / <= Down_icon $mol_icon_arrow_down_bold
				click? <=> down? null
		<= Right $mol_button_major
			sub / <= Right_icon $mol_icon_arrow_right_bold
			click? <=> right? null
